import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** * * Toast * */

/* eslint-disable consistent-return */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from '@fil-react-components/spinner';
import withStyles from '@fil-react-components/with-styles';
import { BaseButton } from '@fil-react-components/button';
import { Cell, Grid } from '@fil-react-components/grid';
import Icon from '@fil-react-components/icon';
import styles from './Toast.style';
import { DEVICE_MOBILE, SUCCESS, ERROR, INFO, LOADING, WARNING } from './constants';
var getStatusIcon = function getStatusIcon(appearance) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, appearance === SUCCESS && /*#__PURE__*/React.createElement(Icon, {
    iconType: "circle-tick",
    className: "toast__status--success"
  }), appearance === WARNING && /*#__PURE__*/React.createElement(Icon, {
    iconType: "warning-triangle-filled",
    className: "toast__status--warning"
  }), appearance === ERROR && /*#__PURE__*/React.createElement(Icon, {
    iconType: "warning-triangle-filled",
    className: "toast__status--error"
  }), appearance === INFO && /*#__PURE__*/React.createElement(Icon, {
    iconType: "warning-circle-filled",
    className: "toast__status--info"
  }), appearance === LOADING && /*#__PURE__*/React.createElement(Spinner, {
    isVisible: true,
    displayType: "inline",
    size: "small",
    className: "toast__status--loading"
  }));
};
var Toast = /*#__PURE__*/function (_PureComponent) {
  function Toast() {
    _classCallCheck(this, Toast);
    return _callSuper(this, Toast, arguments);
  }
  _inherits(Toast, _PureComponent);
  return _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        removeToast = _this$props.removeToast,
        autoDismiss = _this$props.autoDismiss,
        autoDismissTimeout = _this$props.autoDismissTimeout,
        toastId = _this$props.toastId;
      if (autoDismiss) {
        var removeCurrentToast = function removeCurrentToast() {
          return removeToast(toastId);
        };
        _setTimeout(removeCurrentToast, autoDismissTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        removeToast = _this$props2.removeToast,
        deviceType = _this$props2.deviceType,
        appearance = _this$props2.appearance,
        children = _this$props2.children,
        toastId = _this$props2.toastId,
        className = _this$props2.className;
      return /*#__PURE__*/React.createElement("div", {
        className: "toast ".concat(className)
      }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Cell, {
        sm: 2,
        className: "toast__status"
      }, getStatusIcon(appearance)), /*#__PURE__*/React.createElement(Cell, {
        sm: 9
      }, /*#__PURE__*/React.createElement("div", {
        className: "toast__title"
      }, title), deviceType !== DEVICE_MOBILE && appearance !== INFO && /*#__PURE__*/React.createElement("div", {
        className: "toast__text"
      }, children)), /*#__PURE__*/React.createElement(Cell, {
        sm: 1
      }, /*#__PURE__*/React.createElement(BaseButton, {
        onClick: removeToast,
        "data-toast-id": toastId
      }, /*#__PURE__*/React.createElement(Icon, {
        variant: "light",
        iconType: "cross",
        className: "toast__close"
      })))));
    }
  }]);
}(PureComponent);
_defineProperty(Toast, "defaultProps", {
  appearance: 'success',
  title: '',
  autoDismiss: false,
  autoDismissTimeout: null,
  deviceType: '',
  removeToast: null,
  toastId: '',
  className: ''
});
_defineProperty(Toast, "propTypes", {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  appearance: PropTypes.string,
  autoDismiss: PropTypes.bool,
  autoDismissTimeout: PropTypes.number,
  deviceType: PropTypes.string,
  removeToast: PropTypes.func,
  toastId: PropTypes.string,
  className: PropTypes.string
});
_defineProperty(Toast, "displayName", 'Toast');
export default withStyles(Toast, styles);